module.exports = __webpack_public_path__ + "static/media/great-learning-ui-study.a5cfb77f.jpg";